/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import { reatomBigNumber, reatomBigNumberComputed } from '@root/shared/lib'

import type { ServicesApi } from '@root/shared/api'

export const reatomPairFees = (dto: ServicesApi.PairDto) => {
  const totalPriorityFeesAtom = reatomBigNumber(dto.fees.totalPriorityFees)
  const totalBundleTipsFeesAtom = reatomBigNumber(dto.fees.totalBundleTipFees)
  const totalNetworkFeesAtom = reatomBigNumber(dto.fees.totalNetworkFees)
  const totalFeesAtom = reatomBigNumberComputed((ctx) => {
    const priorityFees = ctx.spy(totalPriorityFeesAtom)
    const totalBundleTipsFees = ctx.spy(totalBundleTipsFeesAtom)
    return priorityFees.plus(totalBundleTipsFees)
  })

  const updateFromDtoAction = action(
    (ctx, dto: ServicesApi.PairDto['fees']) => {
      totalPriorityFeesAtom.set(ctx, dto.totalPriorityFees)
      totalBundleTipsFeesAtom.set(ctx, dto.totalBundleTipFees)
      totalNetworkFeesAtom.set(ctx, dto.totalNetworkFees)
    },
  )

  return {
    totalFees: totalFeesAtom,
    totalPriorityFees: totalPriorityFeesAtom,
    totalBundleTipsFees: totalBundleTipsFeesAtom,
    totalNetworkFees: totalNetworkFeesAtom,
    updateFromDtoAction,
  }
}

export type PairFeesModel = Omit<
  ReturnType<typeof reatomPairFees>,
  'updateFromDtoAction'
>
